import { Modal, Space, Spin } from "antd";

type Props = {
  open: boolean
}

const CheckingForAffectedJobsModal = ({ open }: Props) => {
  return (
    <Modal closable={false} footer={null} open={open} centered>
      <Space>
        <Spin />
        <p>Searching for jobs that use this item...</p>
      </Space>
    </Modal>
  )
}

export default CheckingForAffectedJobsModal;
